export function DmapLink({ href }: { href: string }) {
  return (
    <a
      className="ph-actionlink"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open DMAP (opens in new tab)"
      title="DMAP"
    >
      <svg
        className="ph-actionlink-icon"
        viewBox="0 0 16 16"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M1.75 3.5 5.5 2l5 1.5L14.25 2v10.5L10.5 14l-5-1.5L1.75 14V3.5Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 2v10.5M10.5 3.5V14"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        />
      </svg>
      <span className="ph-actionlink-l">DMAP</span>
    </a>
  );
}
